import { render, staticRenderFns } from "./dataManagement.vue?vue&type=template&id=78d164be&scoped=true&"
import script from "./dataManagement.vue?vue&type=script&lang=js&"
export * from "./dataManagement.vue?vue&type=script&lang=js&"
import style0 from "./dataManagement.vue?vue&type=style&index=0&id=78d164be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d164be",
  null
  
)

export default component.exports